import React, { useState } from 'react';
import Login from './Login';

console.log('🔄 AUTH-CONTAINER: Fresh component loaded');

const AuthContainer = () => {
  console.log('🔍 AUTH-CONTAINER: Rendering...');
  
  const [currentView, setCurrentView] = useState('login');
  
  console.log('🔍 AUTH-CONTAINER: Current view:', currentView);

  const handleSwitchToSignUp = () => {
    console.log('🔄 AUTH-CONTAINER: Switching to signup');
    setCurrentView('signup');
  };

  const handleForgotPassword = () => {
    console.log('🔄 AUTH-CONTAINER: Forgot password clicked');
    // TODO: Implement forgot password
  };

  // For now, always show login
  return (
    <Login 
      onSwitchToSignUp={handleSwitchToSignUp}
      onForgotPassword={handleForgotPassword}
    />
  );
};

export default AuthContainer;